import { Provider } from './../../models/Provider';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { Control } from './../../models/Control';
import { UserCreditInfo } from './../../models/UserCreditInfo';


export interface ChartData {
  data: number[];
  labels: string[];
}

@Injectable({ providedIn: 'root' })
export class ProviderService {

  constructor(private http: HttpClient) { }


  providerCredits(): Observable<Provider[]> {
    return this.http.get<Provider[]>(`${environment.apiUrl}/provider-credits`);
  }

  updateProvider(provider: Provider): Observable<any> {
    return this.http.put(`${environment.apiUrl}/provider/${provider.id}`, provider);
  }

}
